// The console's "Subscribed" list — which unique numbers the Filtered pane shows.
//
// Persisted, so a session that was watching four devices is still watching them
// after a restart. Kept out of the app's normal per-device subscriptions: this
// is a diagnostic view, and closing the console must not disturb what the rest
// of the app is listening to.
//
// The monitor already receives every device topic via its wildcard, so this list
// is purely a FILTER — adding one costs no extra broker subscription.

const KEY = 'sli_console_subs';

let subs = [];
const listeners = new Set();

function persist() {
  try { localStorage.setItem(KEY, JSON.stringify(subs)); } catch (e) { /* ignore */ }
  listeners.forEach((fn) => { try { fn(subs); } catch (e) { /* ignore */ } });
}

export function loadSubs() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    subs = Array.isArray(parsed) ? parsed.filter((s) => s && s.uniqueNumber) : [];
  } catch (e) {
    subs = [];
  }
  return subs;
}

export const getSubs = () => subs;

export function onSubsChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function addSub(uniqueNumber, label) {
  const uno = String(uniqueNumber || '').trim();
  if (!uno) return false;
  if (subs.some((s) => s.uniqueNumber === uno)) return false;
  subs = [...subs, { uniqueNumber: uno, label: label || uno }];
  persist();
  return true;
}

export function removeSub(uniqueNumber) {
  subs = subs.filter((s) => s.uniqueNumber !== String(uniqueNumber));
  persist();
}

export function clearSubs() {
  subs = [];
  persist();
}

export const isSubscribed = (uniqueNumber) =>
  subs.some((s) => s.uniqueNumber === String(uniqueNumber));
